
import React from 'react';
import customStyles from "../../../../../../assets/styles/customStyles";
import { PrimaryDrawer } from "../../../../../Shared/components/Drawer/PrimaryDrawer";
import { Row, Col, Space } from "antd";
import { Button, TextField, Box, Typography, FormControlLabel, Switch, InputAdornment } from "@mui/material";
import clsx from "clsx";
import { AutoCompleteComponent } from "../../../../../Shared/components/AutoCompleteComponent";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import moment from 'moment';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import DateIcon from "../../../../../Shared/components/Icons/Date";
import { currencyFormat, idNamingConversion } from "../../../../../../helpers/utilities";
import CustomAlert from "../../../../../Shared/components/CustomAlert";
import dayjs from 'dayjs';

export const PurchaseCustomForm = (props) => {
    const { createLoader, editLoader } = useSelector(state => state.crudReducer);
    const { myProductdetails } = useSelector(state => state.productProductReducer);
    const { supplierDetails } = useSelector(state => state.purchaseManagementReducer);
    const { unitMesurementdetails } = useSelector(state => state.productSetupReducer);
    const { form, view, priceId, handleClose, handleSubmit,
        handleIsActive, visible, error, changeHandler, handleProductChange, commonError,
        handleEdit, title, customObject, supplierId, productApi } = props;
    const classes = customStyles();
    return (
        <PrimaryDrawer
            anchor={'right'}
            open={visible}
            variant={'temporary'}
            handleClose={() => handleClose()}
            title={`${priceId ? `${view ? 'View' : 'Edit'}` : 'Create'} ${title}`}
            width={'690px'}
            className={clsx(classes.closeBackGround, classes.width100PCustomerandSales)}
            component={
                <Box
                    className={clsx(classes.customForm, classes.removeUnderline)}
                    component="form"
                    autoComplete="off"
                    onSubmit={(e) => handleSubmit(e)}>
                    <div className={classes.customFormFlex}>
                        <Row type="flex" gutter={40}>
                            {
                                commonError && <Col span={24} className={clsx(classes.textAlignCenter, classes.marginBottom10)}><CustomAlert error={commonError} customClass={clsx(classes.uploadError)} /></Col>
                            }
                            <Col xxs={8} xx={8} lg={8} md={8} sm={8} xs={24}>
                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Price ID</Typography>
                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.purchasePriceId || '---'}</Typography>
                            </Col>
                            <Col xxs={8} xx={8} lg={8} md={8} sm={8} xs={24}>
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.collectPaymentSpefic, 'MuiInputLabel-shrink', classes.fonSize13)}>Active</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.isActive ? 'Yes' : 'No'}</Typography>
                                    </> : <FormControlLabel
                                        classes={{ label: clsx(classes.fonSize13, 'MuiInputLabel-shrink', classes.textFieldLableColorCustom) }}
                                        control={<Switch size='small' className={clsx(classes.customSwitch)} onChange={(e) => handleIsActive(!form?.isActive)} />}
                                        label="Active"
                                        id={idNamingConversion('Status', 'purchasePrice', 'Radio')}
                                        labelPlacement="top"
                                        checked={form?.isActive}
                                        className={clsx(classes.marginLeft0, classes.flexStart, classes.collectPaymentSpefic)}
                                    />
                                }
                            </Col>
                            <Col xxs={8} xx={8} lg={8} md={8} sm={8} xs={24}>
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.collectPaymentSpefic, 'MuiInputLabel-shrink', classes.fonSize13)}>In App Status</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.isInApp ? 'Yes' : 'No'}</Typography>
                                    </> : <FormControlLabel
                                        classes={{
                                            label: clsx(classes.fonSize13, 'MuiInputLabel-shrink', classes.textFieldLableColorCustom),
                                        }}
                                        id={idNamingConversion('In-App', 'purchasePrice', 'Radio')}
                                        control={<Switch size='small' className={clsx(classes.customSwitch)} />}
                                        label="In-App"
                                        labelPlacement="top"
                                        checked={form?.isInApp ? form?.isInApp : false}
                                        className={clsx(classes.marginLeft0, classes.flexStart, classes.collectPaymentSpefic)}
                                    />
                                }
                            </Col>
                            <Col xxs={8} xx={8} lg={8} md={8} sm={8} xs={24}>
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin20t)}>Product</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.product?.productName || '---'}</Typography>
                                    </> : <AutoCompleteComponent
                                        name={["Product ", <span key={"Product"} className={classes.colorRedRequired}> *</span>]}
                                        heads={[{ 'key': 'productName', 'name': 'Product Name' },
                                        { 'key': 'productId', 'name': 'Product ID' }, { 'key': 'universalProduct', 'name': 'UPI Id', 'relation': 'productId' }]}
                                        details={myProductdetails}
                                        id={idNamingConversion('Product', 'purchasePrice', 'DropDown')}
                                        parentValue={customObject(myProductdetails, form?.productId)}
                                        onChange={(data) => handleProductChange(data)}
                                        position={"bottom"}
                                        searchType={(s) => productApi(s)}
                                        customClasses={classes.margin20t} parentError={error?.productId}
                                    />
                                }
                            </Col>

                            <Col xxs={8} xx={8} lg={8} md={8} sm={8} xs={24}>
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin20t)}>Unit</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.unit?.name || '---'}</Typography>
                                    </> : <AutoCompleteComponent
                                        name={["Unit ", <span key={"Unit"} className={classes.colorRedRequired}> *</span>]}
                                        heads={[{ 'key': 'name', 'name': 'Unit' },
                                        { 'key': 'description', 'name': 'Description' }]}
                                        details={unitMesurementdetails}
                                        id={idNamingConversion('Unit', 'purchasePrice', 'DropDown')}
                                        parentValue={customObject(unitMesurementdetails, form?.unitId)}
                                        onChange={(data) => changeHandler(data.id, 'unitId')}
                                        position={"bottom"}
                                        customClasses={classes.margin20t}
                                        parentError={error?.unitId}
                                    />
                                }
                            </Col>
                            <Col xxs={8} xx={8} lg={8} md={8} sm={8} xs={24}>
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin20t)}>Price</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.price ? `₹ ${currencyFormat(form?.price)}` : '---'}</Typography>
                                    </> : <TextField autoComplete='one-time-code'
                                        className={clsx(classes.margin20t)}
                                        label={["Price ", <span key={"Price"} className={classes.colorRedRequired}> *</span>]}
                                        type={'number'}
                                        variant={'standard'}
                                        name={'price'}
                                        error={error?.price ? true : false}
                                        helperText={error?.price}
                                        disabled={(form?.dynamicPrice === 'MARGIN' || form?.dynamicPrice === 'PRICE-PURCHASE PRICE MARKUP') ? true : false}
                                        onWheel={(e) => e.target.blur()}
                                        value={form?.price || ''}
                                        fullWidth
                                        id={idNamingConversion('Price', 'purchasePrice', 'TextField')}
                                        InputProps={{
                                            startAdornment: <InputAdornment className={clsx(classes.textFieldColor)} position="start">₹ </InputAdornment>,
                                            classes: {
                                                input: clsx(classes.textFieldColor, classes.nonEditable)
                                            },
                                            inputProps: { step: "any" }
                                        }}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom,
                                        }}
                                        onChange={(e) => e.target.value !== '' ? e.target.value < 0 ? e.target.value = 0 : changeHandler(e) : changeHandler(e)}
                                    />
                                }
                            </Col>
                            <Col xxs={8} xx={8} lg={8} md={8} sm={8} xs={24}>
                                <div className={clsx(classes.margin20t, classes.dateAdjust)}>
                                    {
                                        view ? <>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>From Date</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                {form.fromDate ? moment(form.fromDate).format('DD MMM YYYY') : '---'}
                                            </Typography>
                                        </> : <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DesktopDatePicker
                                                fullWidth
                                                slots={{
                                                    openPickerIcon: DateIcon
                                                }}
                                                views={['year', 'month', 'day']}
                                                minDate={new Date()}
                                                value={form?.fromDate ? dayjs(form?.fromDate).$d : null}
                                                label={"From Date"}
                                                name={"fromDate"}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor
                                                    }
                                                }}
                                                slotProps={{
                                                    textField: {
                                                        id: idNamingConversion('From Date', 'purchasePrice', 'TextField'),
                                                        autoComplete: 'one-time-code'
                                                    },
                                                }}
                                                format="dd/MM/yyyy"
                                                onChange={(newValue, newError) => {
                                                    if (newError?.validationError) {
                                                        changeHandler(new Date(), 'fromDate')
                                                    } else {
                                                        changeHandler(newValue, 'fromDate')
                                                    }
                                                }}
                                            />
                                        </LocalizationProvider>
                                    }
                                </div>
                            </Col>
                            <Col xxs={8} xx={8} lg={8} md={8} sm={8} xs={24}>
                                <div className={clsx(classes.margin20t, classes.dateAdjust)}>
                                    {
                                        view ? <>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>To Date</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                {form.toDate ? moment(form.toDate).format('DD MMM YYYY') : '---'}
                                            </Typography>
                                        </> : <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DesktopDatePicker
                                                fullWidth
                                                slots={{
                                                    openPickerIcon: DateIcon
                                                }}
                                                views={['year', 'month', 'day']}
                                                minDate={form?.fromDate ? new Date(form?.fromDate) : new Date()}
                                                value={form?.toDate ? dayjs(form?.toDate).$d : null}
                                                label={"To Date"}
                                                name={"toDate"}
                                                slotProps={{
                                                    textField: {
                                                        error: error?.toDate ? true : false,
                                                        helperText: error?.toDate,
                                                        id: idNamingConversion('To Date', 'purchasePrice', 'TextField'),
                                                        autoComplete: 'one-time-code'
                                                    },
                                                }}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor
                                                    }
                                                }}
                                                format="dd/MM/yyyy"
                                                onChange={(newValue, newError) => {
                                                    if (newError?.validationError) {
                                                        changeHandler(new Date(), 'toDate')
                                                    } else {
                                                        changeHandler(newValue, 'toDate')
                                                    }
                                                }}
                                            />
                                        </LocalizationProvider>
                                    }
                                </div>
                            </Col>
                            <Col xxs={8} xx={8} lg={8} md={8} sm={8} xs={24}></Col>
                            <Col xxs={8} xx={8} lg={8} md={8} sm={8} xs={24}>
                                {
                                    (view || supplierId) ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin20t)}>Supplier Name</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.supplier?.name || '---'}</Typography>
                                    </> :
                                        <AutoCompleteComponent
                                            name={["Supplier Name ", <span key={"Supplier Name"} className={classes.colorRedRequired}> *</span>]}
                                            heads={[{ 'key': 'name', 'name': 'Supplier Name' },
                                            { 'key': 'mobile', 'name': 'Phone Number' },
                                            { 'key': 'serialNo', 'name': 'Supplier ID' }]}
                                            details={supplierDetails}
                                            id={idNamingConversion('Supplier Name', 'purchasePrice', 'DropDown')}
                                            parentValue={customObject(supplierDetails, form?.supplierId)}
                                            onChange={(data) => { changeHandler(data.id, 'supplierId') }}
                                            position={"bottom"}
                                            customClasses={classes.margin20t}
                                            parentError={error?.supplierId}
                                        />
                                }
                            </Col>
                            <Col xxs={8} xx={8} lg={8} md={8} sm={8} xs={24}>
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin20t)}>Cost Price</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.cost || '---'}</Typography>
                                    </> :
                                        <TextField autoComplete='one-time-code'
                                            className={clsx(classes.margin20t)}
                                            label={["Cost Price"]}
                                            type={'number'}
                                            variant={'standard'}
                                            onWheel={(e) => e.target.blur()}
                                            name={'cost'}
                                            error={error?.cost ? true : false}
                                            helperText={error?.cost}
                                            value={form?.cost || ''}
                                            fullWidth
                                            id={idNamingConversion('Cost Price', 'purchasePrice', 'TextField')}
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                },
                                                inputProps: { step: "any" }
                                            }}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                            }}
                                            onChange={(e) => e.target.value !== '' ? e.target.value < 0 ? e.target.value = 0 : changeHandler(e) : changeHandler(e)}
                                        />
                                }
                            </Col>
                            <Col xxs={8} xx={8} lg={8} md={8} sm={8} xs={24}>
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin20t)}>Latest Purchase Price</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.lastPurchasePrice || '---'}</Typography>
                                    </> :
                                        <TextField autoComplete='one-time-code'
                                            className={clsx(classes.margin20t)}
                                            label={["Latest Purchase Price "]}
                                            type={'number'}
                                            id={idNamingConversion('Latest Purchase Price', 'purchasePrice', 'TextField')}
                                            onWheel={(e) => e.target.blur()}
                                            variant={'standard'}
                                            name={'lastPurchasePrice'}
                                            error={error?.lastPurchasePrice ? true : false}
                                            helperText={error?.lastPurchasePrice}
                                            value={form?.lastPurchasePrice || ''}
                                            fullWidth
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                },
                                                inputProps: { step: "any" }
                                            }}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                            }}
                                            onChange={(e) => changeHandler(e)}
                                        />
                                }
                            </Col>
                            <Col xxs={8} xx={8} lg={8} md={8} sm={8} xs={24}>
                                {
                                    view ?
                                        <>
                                            <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Use MRP</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                {form?.useMrp ? 'Yes' : 'No'}
                                            </Typography>
                                        </> :
                                        <FormControlLabel
                                            classes={{
                                                label: clsx(classes.fonSize13, classes.noWrap, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink'), // Pass your override css here
                                            }}
                                            control={<Switch size='small' className={clsx(classes.customSwitch)}
                                                onChange={(e) => changeHandler(e, 'useMrp')}
                                            />}
                                            id={idNamingConversion('Use MRP', 'purchasePrice', 'Radio')}
                                            label="Use MRP"
                                            labelPlacement="top"
                                            checked={form?.useMrp ? true : false}
                                            className={clsx(classes.marginLeft0, classes.margin20t, classes.flexStart)}
                                        />
                                }
                            </Col>
                            <Col xxs={8} xx={8} lg={8} md={8} sm={8} xs={24}>
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin20t)}>MRP</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.maxRetailPrice || '---'}</Typography>
                                    </> :
                                        <TextField autoComplete='one-time-code'
                                            className={clsx(classes.margin20t)}
                                            label={["MRP "]}
                                            variant={'standard'}
                                            onWheel={(e) => e.target.blur()}
                                            name={'maxRetailPrice'}
                                            id={idNamingConversion('MRP', 'purchasePrice', 'TextField')}
                                            error={error?.maxRetailPrice ? true : false}
                                            helperText={error?.maxRetailPrice}
                                            value={form?.maxRetailPrice || ''}
                                            fullWidth
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                },
                                                inputProps: { step: "any" }
                                            }}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                            }}
                                            onChange={(e) => e.target.value !== '' ? e.target.value < 1 ? e.target.value = 1 : changeHandler(e) : changeHandler(e)}
                                        />
                                }
                            </Col>
                            <Col xxs={8} xx={8} lg={8} md={8} sm={8} xs={24}>
                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin20t)}>Refrence Price Id</Typography>
                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.salesPriceId || '---'}</Typography>
                            </Col>
                            <Col span={8}>
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin20t)}>S.E.D- Special Excise Duty (%)</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.specialExcisesDutyPercentage || '---'}</Typography>
                                    </> : <>
                                        {
                                            !form?.useMrp ? <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin20t)}>S.E.D- Special Excise Duty (%)</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.specialExcisesDutyPercentage || '---'}</Typography>
                                            </> : <TextField autoComplete='one-time-code'
                                                className={clsx(classes.margin20t)}
                                                label={["S.E.D- Special Excise Duty (%)"]}
                                                type={'number'}
                                                id={idNamingConversion('S.E.D- Special Excise Duty  (%)', 'salesPrice', 'TextField')}
                                                onWheel={(e) => e.target.blur()}
                                                variant={'standard'}
                                                name={'specialExcisesDutyPercentage'}
                                                value={form?.specialExcisesDutyPercentage || ''}
                                                fullWidth
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    },
                                                    inputProps: { step: "any" }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => changeHandler(e.target.value, 'specialExcisesDutyPercentage')}
                                            />
                                        }
                                    </>
                                }
                            </Col>
                            <Col span={8}>
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin20t)}>S.E.D- Special Excise Duty</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.specialExcisesDuty || '---'}</Typography>
                                    </> : <>
                                        {
                                            form?.useMrp ? <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin20t)}>S.E.D- Special Excise Duty</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.specialExcisesDuty || '---'}</Typography>
                                            </> : <TextField autoComplete='one-time-code'
                                                className={clsx(classes.margin20t)}
                                                label={["S.E.D- Special Excise Duty"]}
                                                type={'number'}
                                                id={idNamingConversion('S.E.D- Special Excise Duty', 'salesPrice', 'TextField')}
                                                onWheel={(e) => e.target.blur()}
                                                variant={'standard'}
                                                name={'specialExcisesDuty'}
                                                value={form?.specialExcisesDuty || ''}
                                                fullWidth
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    },
                                                    inputProps: { step: "any" }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => changeHandler(e.target.value, 'specialExcisesDuty')}
                                            />
                                        }
                                    </>

                                }
                            </Col>
                        </Row>
                    </div>
                    {
                        handleEdit && <div className={clsx(classes.btnParent)}>
                            {
                                !view ?
                                    <Space size={[10, 10]} direction="horizontal" align="center">
                                        <Button
                                            key="save"
                                            color="primary"
                                            variant="contained"
                                            id={idNamingConversion('Save', 'purchasePrice', 'Button')}
                                            type={'submit'}
                                            className={clsx(classes.modalBtn, { [classes.loading]: createLoader || editLoader })}>
                                            {
                                                priceId ? 'Update & Close' : 'Save & Close'
                                            }
                                        </Button>
                                    </Space> : <NavLink to={'#'} id={idNamingConversion('Save', 'purchasePrice', 'Link')} className={clsx(classes.modalBtn)} onClick={() => handleEdit(false)}>Edit</NavLink>
                            }
                        </div>
                    }
                </Box>
            }
        />
    )
}